import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CaasViewer from '@adsk/ha-caas-viewer';
import { adpDotcomLoggerUtil } from '@adsk/ha-adp-dotcom-logger-util';
import {
  activateLanguage,
  defaultLanguageCountry
} from '../utils/languageSupport';
import { ENVIRONMENT } from '../common/constants';
import EnvContext from '../common/envContext';
import { checkElement } from '../../App';

const Caas = () => {
  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];
  const caasData = useSelector((state) => state.caasData);
  const language = envContext.LANGUAGE || defaultLanguageCountry;
  const adpConfig = envContext.ADP_CONFIG;
  const server = {
    adpConfig
  };
  const tracker = adpDotcomLoggerUtil(server);
  let productLine = null;
  if (caasData?.response?.productLine?.length) {
    productLine = caasData?.response?.productLine[0];
  }
  const dispatch = useDispatch();
  useEffect(() => {
    activateLanguage(language);
  }, [language, env, caasData, dispatch]);

  useEffect(() => {
    checkElement('#caas-viewer a', false).then((selector) => {
      const includedExtensions = [
        '.tgz',
        '.msp',
        '.msi',
        '.exe',
        '.dll',
        '.zip',
        '.txt',
        '.pdf',
        '.docx'
      ];
      const allUrls = Object.values(selector);

      // Download click tracking
      allUrls.forEach((anchor) => {
        const isDownloadable = includedExtensions.some((keyword) =>
          anchor.href.includes(keyword)
        );
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          const trackerEvent = e.target.closest('a').href;
          if (isDownloadable) {
            // download click tracking
            tracker.track('download_click', {
              ev: trackerEvent,
              product: productLine
            });
          } else {
            // non-download click tracking
            tracker.track('emb_link_click', {
              ev: trackerEvent
            });
          }
          window.top.location.href = trackerEvent;
        });
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <I18nProvider i18n={i18n}>
      <CaasViewer
        data={caasData}
        language={language}
        showAnalytics
        adpConfig={envContext.ADP_CONFIG}
        showContactSupport
      />
    </I18nProvider>
  );
};

export default Caas;
